import { call } from 'redux-saga/effects';

import { clearDataFromLocalStorage } from '../../utils';

/**
 * Problem:
 * Local storage may contain outdated or unnecessary data related to the reader task viewer, which can lead to inconsistencies or unexpected behavior.
 *
 * Solution:
 * This worker clears the relevant local storage to ensure a clean state for the reader task viewer.
 */
export function* clearLSWorker() {
  yield call(clearDataFromLocalStorage);
}
